import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/Date.css";

const DatePickerComponent = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (onDateChange) {
      onDateChange({ start, end });
    }
  };

  const clearDates = () => {
    setStartDate(null);
    setEndDate(null);
    if (onDateChange) {
      onDateChange({ start: null, end: null });
    }
  };

  return (
    <div className="date-picker-container">
      <div className="date-picker-wrapper">
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          dateFormat="yyyy-MM-dd"
          placeholderText="Select Date"
          className={`custom-datepicker ${startDate ? "expanded" : ""}`} // Add class based on date selection
        />
        {startDate && (
          <button className="clear-btn" onClick={clearDates}>
            ✖
          </button>
        )}
      </div>
    </div>
  );
};

export default DatePickerComponent;
